import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateAddressLine,
	validateText,
	validateEmail,
	validatePhoneNumber,
	validatePostcode,
	validateWebsite,
} from '../../../util/validation/commonValidation';
import type { UpsertSupplierDto } from '../types/SupplierDto';

const defaultSupplier: UpsertSupplierDto = {
	id: 0,
	name: '',
	ref: '',
	branchIds: [],
};

export function useUpsertSupplierForm(
	supplier: UpsertSupplierDto = defaultSupplier,
) {
	const [inputs, setInputs] = useState<UpsertSupplierDto>(supplier);

	const form = useForm<UpsertSupplierDto>({
		mode: 'uncontrolled',
		initialValues: supplier,
		validate: {
			name: (value) => validateText(value, false, 'Supplier name'),
			ref: (value) => {
				if (value.length < 1) {
					return 'Supplier reference cannot be empty';
				}
				if (value.length > 70) {
					return 'Supplier reference cannot exceed 70 characters';
				}
				if (value.length >= 1 && !/^[a-zA-Z0-9. _']{1,}$/.test(value)) {
					return 'Supplier reference can only contain apostrophes, letters, numbers, dots or spaces ';
				}
			},
			branchIds: (value) => {
				if (value.length < 1) {
					return 'At least one branch must be selected ';
				}
			},
			address: (value) => validateAddressLine(value, true),
			town: (value) => validateText(value, true, 'Town name'),
			county: (value) => validateText(value, true, 'County name'),
			postCode: (value) => validatePostcode(value, true),
			phone: (value) => validatePhoneNumber(value, true),
			email: (value) => validateEmail(value, true),
			website: (value) => validateWebsite(value, true),
			accountNo: (value) => {
				if (value && value.length > 70) {
					return 'Account number cannot exceed 70 characters';
				}
				if (value && value.length >= 1 && !/^[a-zA-Z0-9. _]{1,}$/.test(value)) {
					return 'Account number can only contain letters, numbers, dots or spaces';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
